import React from 'react';
import { useTranslation } from 'react-i18next';
import '../style/OurStory.css';

const OurStory = () =>{
    const { t } = useTranslation();

    return(
        <div className='OurStory'>
            <h1>{t('ourStory.title')}</h1>
            <p>
                {t('ourStory.p1')}<br/>
                {t('ourStory.p2')}
            </p>

            <p>
                {t('ourStory.p3')}<br/>
                {t('ourStory.p4')}
            </p>

            <p>
                {t('ourStory.p5')}
            </p>

            <p>
                {t('ourStory.p6')}<br/>
                {t('ourStory.p7')}<br/>
                {t('ourStory.p8')}<br/>
                {t('ourStory.p9')}
                <br/><br/>
                {t('ourStory.p10')}
            </p>
        </div>
    )
}

export default OurStory; 